export function StripAlphaCharacters(modifiedValue: any){
     // Recalculate value after ignoring "$" and "," in user input
     let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
     // Ensure that it is not NaN
     if (isNaN(newValue)) {
         newValue = 0
     }
     return newValue;
}


// WEBPACK FOOTER //
// ./@modules/utils/currency-field.ts